var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "setStation",
      attrs: {
        title: "设置站点",
        visible: _vm.visible,
        "append-to-body": true,
        width: "50%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            load: _vm.loading,
            data: _vm.data,
            border: false,
            height: "280px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              prop: "index",
              width: "50",
              type: "index",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "类型",
              prop: "type",
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.index === _vm.start
                      ? _c("div", [_vm._v("\n          起点\n        ")])
                      : _vm._e(),
                    scope.row.index > 0 && scope.row.index < _vm.end
                      ? _c("div", [_vm._v("\n          经过\n        ")])
                      : _vm._e(),
                    scope.row.index === _vm.end
                      ? _c("div", [_vm._v("\n          终点\n        ")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "站点名称",
              prop: "stationName",
              width: "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "上下规则", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("rulesFilters")(scope.row.rule))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "关闭站点", align: "center", prop: "isOpen" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("avue-switch", {
                      attrs: {
                        "active-color": _vm.activeColor,
                        dic: [{ value: 2 }, { value: 1 }],
                      },
                      model: {
                        value: scope.row.isOpen,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "isOpen", $$v)
                        },
                        expression: "scope.row.isOpen",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.save },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }